<template>
  <div class="password">
    <span class="ball ball-1"></span>
    <span class="ball ball-2"></span>
    <span class="ball ball-3"></span>
    <span class="ball ball-4"></span>
    <span class="ball ball-5"></span>
    <ul>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
      <li>
        <span class="ball"></span>
      </li>
    </ul>
    <el-form
      v-if="!reseting"
      ref="passwordForm"
      v-loading="loading"
      :model="passwordForm"
      :rules="passwordRules"
      class="password-form"
      auto-complete="off"
      size="big"
      label-position="left"
    >
      <div class="title">{{ '找回密码' }}</div>
      <el-form-item prop="mobile">
        <el-input
          v-model="passwordForm.mobile"
          placeholder="请输入手机号码"
          prefix-icon="el-icon-mobile-phone"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input
          v-model="passwordForm.code"
          prefix-icon="el-icon-message"
          placeholder="请输入短信验证码"
          clearable
        >
          <template slot="append">
            <el-button style="width: 140px;" :loading="btnLoading" @click="sendCode">
              <span v-if="!sending && !times">获取验证码</span>
              <span v-if="!sending && times">重新获取验证码</span>
              <span v-if="sending">{{ interval - counter }}秒后重发</span>
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="pw">
        <el-popover placement="right-start" width="285" trigger="click">
          <li>6-20个字符，密码不能和用户名相同</li>
          <li>只能包含字母、数字以及标点符号（除空格）</li>
          <el-input
            slot="reference"
            v-model="passwordForm.pw"
            placeholder="请设置新密码"
            prefix-icon="el-icon-lock"
            clearable
          ></el-input>
        </el-popover>
      </el-form-item>
      <el-form-item prop label>
        <el-button class="submit" type="primary" :loading="postLoading" @click="handleReset()">确 定</el-button>
      </el-form-item>
      <div class="flex justify-content-center">
        <span class="text-muted">
          <span>密码已找回？</span>
          <el-button class="relogin-btn" type="text" @click="handleRelogin">重新登录</el-button>
        </span>
      </div>
    </el-form>

    <el-form v-else class="password-form flex-center column">
      <i class="el-icon-success font-10x text-success"></i>
      <div class="title mt mb">新密码设置成功</div>
      <el-button type="primary" @click="handleRelogin">返回登录 {{ intervalBack - counterBack }}s</el-button>
    </el-form>
  </div>
</template>

<script>
import { validateRamUsername, validateNumber } from "@/utils/validate";
import { resetApi } from "@/api/common/registerApi";

export default {
  name: "Password",

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (validateRamUsername(value)) {
          callback();
        } else {
          return callback(new Error("密码格式不正确！"));
        }
      }
    };

    var validateCheckpass = (rule, value, callback) => {
      if (value !== this.passwordForm.pw)
        callback(new Error("两次密码输入不一致"));
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        callback();
      }
    };

    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入11位手机号码"));
      } else {
        // if (this.mobileMsg) callback(new Error(this.mobileMsg))
        if (validateNumber(value)) {
          callback();
        } else {
          return callback(new Error("请输入真实的手机号码！"));
        }
      }
    };

    return {
      times: 0,
      reseting: false,
      // mobileMsg: '',

      sending: false,
      counter: 0,
      interval: 60,

      counterBack: 0,
      intervalBack: 5,

      btnLoading: false,
      loading: false,
      postLoading: false,

      passwordForm: {
        mobile: "",
        code: "",
        pw: "",
        repeat_pw: "",
      },
      passwordRules: {
        pw: [
          {
            min: 6,
            max: 20,
            message: "密码长度应在 6 到 20 个字符",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        repeat_pw: [{ validator: validateCheckpass, trigger: "blur" }],
        mobile: [
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        code: [
          { min: 4, max: 4, message: "请填写正确的验证码", trigger: "blur" },
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
      },
    };
  },

  watch: {
    counter() {
      if (this.counter >= this.interval) {
        this.sending = false;
        this.counter = 0;
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    },

    counterBack() {
      if (this.counterBack >= this.intervalBack) {
        this.handleRelogin();
        this.counterBack = 0;
        if (this.timerBack) {
          clearInterval(this.timerBack);
        }
      }
    },
  },

  created() {},

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  methods: {
    handleRelogin() {
      this.$router.replace("/login");
    },

    sendCode() {
      if (this.sending) return;
      this.btnLoading = true;
      const temp = {
        mobile: this.passwordForm.mobile,
        send: 1,
      };
      resetApi(temp).then((res) => {
        this.btnLoading = false;
        if (!res.errno) {
          this.sending = true;
          this.$message.success("验证码已发送到你的手机，1小时内有效！");
          this.times++;
          this.timer = setInterval(() => {
            this.counter += 1;
          }, 1000);
        } else {
          this.sending = false;
          this.$message.error(res.message);
        }
      });
    },

    handleReset() {
      this.$refs["passwordForm"].validate((valid) => {
        if (valid) {
          this.postLoading = true;
          resetApi(this.passwordForm).then((res) => {
            if (!res.errno) {
              this.reseting = true;
              this.timerBack = setInterval(() => {
                this.counterBack += 1;
              }, 1000);
            } else {
              this.postLoading = false;
              this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.password {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: #f9fffc;

  .ball {
    position: absolute;
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-size: 100% auto;

    &.ball-1 {
      top: 300px;
      left: 160px;
      width: 140px;
      height: 140px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-2 {
      top: 80px;
      left: 80px;
      width: 40px;
      height: 40px;
      transform: rotate(130deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-3 {
      top: -190px;
      left: 50%;
      transform: translateX(-50%) rotate(-90deg);
      width: 320px;
      height: 320px;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
    &.ball-4 {
      top: 180px;
      right: 15%;
      width: 100px;
      height: 100px;
      transform: rotate(90deg);
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    &.ball-5 {
      top: 50%;
      right: 60px;
      width: 120px;
      height: 120px;
      transform: rotate(-90deg);
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      opacity: 0.3;
    }
  }
  .password-form {
    background-color: rgba(255, 255, 255, 0.9);
    width: 400px;
    height: 420px;
    z-index: 999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-66%);
    text-align: center;
    padding: 40px;
    border-radius: 10px;
    box-shadow: -2px 8px 50px 0px rgba(238, 240, 240, 1);
    .title {
      font-size: 28px;
      font-weight: bold;
      letter-spacing: 3px;
      margin-bottom: 24px;
    }
    .el-input {
      .el-input__inner {
        background: transparent;
        color: #fff;
        font-size: 16px;
      }
      .el-input__prefix {
        font-size: 18px;
      }
    }
    .submit {
      width: 100%;
      border-radius: 30px;
      font-size: 16px;
    }
    .register-btn {
      color: #666;
    }
    .relogin-btn {
      color: #07c160;
      margin-top: -22px;
    }
  }

  ul {
    width: 80vw;
    height: 80vw;
    margin: 40px auto;
    position: relative;
    list-style: none;

    li {
      border: 2px solid #ceedd79f;
      position: absolute;
      left: 50%;
      top: 60%;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-name: orbit;
    }
    li .ball {
      display: block;
      position: absolute;
      left: 0;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
      background-size: 100% auto;
    }
    li:nth-child(1) {
      width: 30%;
      height: 30%;
      animation-duration: 14s;
    }
    li:nth-child(1) .ball {
      left: 20%;
      top: 6%;
      width: 20px;
      height: 20px;
      // opacity: 0.3;
    }
    &li:nth-child(2) {
      width: 50%;
      height: 50%;
      animation-duration: 16s;
    }
    li:nth-child(2) .ball {
      left: 75%;
      top: 6%;
      width: 40px;
      height: 40px;
      // opacity: 0.3;
    }
    li:nth-child(3) {
      width: 60%;
      height: 60%;
      animation-duration: 28s;
    }
    li:nth-child(3) .ball {
      width: 60px;
      height: 60px;
      left: 11%;
      top: 11%;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
    li:nth-child(4) {
      width: 100%;
      height: 100%;
      animation-duration: 32s;
      margin-top: 8%;
    }
    li:nth-child(4) > .ball {
      width: 80px;
      height: 80px;
      left: 12%;
      top: 12%;
      transform: rotate(120deg);
      // animation: orbit 180s infinite linear;
      background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    }
  }

  @keyframes orbit {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
}
</style>
